import { useState } from "react";
import { useParams } from "router";
import { useInitializePropertyHandler } from "../initialize/useInitializePropertyHandler";
import { ValidationError } from "../propertyCategory/constants";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { HowManyToList } from "./constants";
import { useHowManyToListValue } from "./howManyToListAtom";

export const useSingleMultipleHandler = () => {
    const value = useHowManyToListValue();
    const { shouldCreatePropertyWithNewEndpoint } = usePropertySelectionViewModelValue();

    const { typeId } = useParams("/:lang/list-my-property/get-started/type/:typeId");

    const [error, setError] = useState<ValidationError | undefined>();

    const { mutate, isLoading } = useInitializePropertyHandler({
        onError: () => {
            setError(ValidationError.Unknown);
        },
    });

    const onBack = () => {
        window.history.back();
    };

    const onNext = () => {
        setError(undefined);

        if (value === undefined) {
            setError(ValidationError.NotSelected);
            return;
        }

        mutate({
            propertyType: Number(typeId),
            isSingleUnit: value === HowManyToList.Single,
            shouldUseNewEndpoint: shouldCreatePropertyWithNewEndpoint,
        });
    };

    return {
        loading: isLoading,
        error,
        onBack,
        onNext,
    };
};
